//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  computed: {
    ...mapState({
      pageData: state => state.pageData
    })
  },
  methods: {
  }
}



// WEBPACK FOOTER //
// ./src/components/ContentHeader.vue